import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow, LinearProgress

} from '@material-ui/core/';

import {coreStyle, EnhancedTableHead} from "../../styles/config";
import Grower from "./add";
import DeleteButton from "../../utils/delete";
import {parseQueryParams} from "../../utils/helpers";
import Resource from "../../crud/resource";
import Search from "../../widgets/Search";
import {useSelector} from "react-redux";
import Translate from "../../utils/utils";

const headCells = [
    {id: 'rfh_number', label: <Translate id={"TABLE.RFH_NUMBER"}/>},
    {id: 'name', label: <Translate id={"TABLE.NAME"}/>},
    {id: 'phone', label: <Translate id={"TABLE.PHONE"}/>},
    {id: 'contact', label: <Translate id={"TABLE.CONTACT"}/>},
    {id: 'status', label: <Translate id={"TABLE.STATUS"}/>},
    {id: 'date', label: <Translate id={"TABLE.DATE"}/>},
    {id: 'actions', label: <Translate id={"TABLE.ACTIONS"}/>},
];

export default function Growers(props) {
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;;
    const [growers, setGrowers] = useState([]);
    const initialValues = {name: "", email: "", phone: "", active: '1', parent_id: null, rfh_number: '', contact: ''};
    const [grower, setGrower] = useState(initialValues);
    const [name, setName] = useState(queryParams.name);
    const [isLoading, setIsLoading] = useState(false);
    const resource = new Resource('grower');
    const [growerParents, setGrowerParents] = useState([]);
    const growerParentResource = new Resource('growerParent');
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });
    const user = useSelector(store => store.auth.user);

    const removeItemInListing = (id) => {
        const remaining = growers.filter((item) => item.id !== id);
        const total = remaining.length;
        setPagination(Object.assign(pagination, {total: pagination.total - 1, 'to': total}));
        setGrowers(remaining);
    };

    useEffect(() => {

        const list = () => {
            const resource = new Resource('grower');
            setIsLoading(true);
            resource.index({
                perPage,
                page,
                name
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setGrowers(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            });

            growerParentResource.index({
                perPage: 300,
            }).then(response => {
                const {data: {data = {data: []}}} = response;
                setGrowerParents(data.data);
                setIsLoading(false);
            }).catch(err => {
                setIsLoading(false);
            });
        };
        list()
    }, [page, perPage]);

    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`?page=${page}&perPage=${perPage}&name=${name}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    const handleCreate = (grower) => {
        const growersList = [grower, ...growers];
        setGrowers(growersList);
    };

    const handleUpdate = (grower) => {
        const growersList = growers.map(item => {
            if (item.id === grower.id) {
                return grower;
            }
            return item;
        });
        setGrowers(growersList);
    };

    const onType = (e) => {
        const {target: {value}} = e;
        setName(value);
    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">
                <Grower handleCreate={handleCreate} resource={resource} initialValues={grower} key={grower.id}
                        handleUpdate={handleUpdate} onCloseModal={() => setGrower(initialValues)}
                        growerParents={growerParents}/>
            </div>

            <Search onType={onType} onSubmit={onSearch} module={"Grower"} onClear={onClearSearch} disabled={isLoading}
                    value={queryParams.name}/>

            {isLoading && <LinearProgress color="secondary"/>}
            <Paper className={coreStyle.paper}>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            rowCount={growers.length}
                            headCells={headCells}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {growers.map(grower => {

                                grower.getStatus = () => {
                                    return grower.active === '1' ? 'active' : 'inactive';
                                };

                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={grower.id}
                                    >
                                        <TableCell>{grower.rfh_number}</TableCell>
                                        <TableCell component="th" scope="row">
                                            {grower.name}
                                        </TableCell>
                                        <TableCell>{grower.phone}</TableCell>
                                        <TableCell>{grower.contact}</TableCell>
                                        <TableCell>
                                            <button
                                                className={` ${grower.getStatus() !== 'active' ? 'text-danger' : ''} button-status `}>{
                                                <Translate id={`TABLE.STATUS.${grower.getStatus().toUpperCase()}`}/>
                                            }</button>
                                        </TableCell>
                                        <TableCell>{grower.created_at}</TableCell>
                                        <TableCell>
                                            <button className='button-edit-delete'
                                                    onClick={() => {
                                                        setGrower(grower)
                                                    }}>
                                                <Translate id={"TABLE.ACTIONS.EDIT"}/>
                                            </button>

                                            {user.role.name !== 'INSPECTOR' &&
                                            <>
                                                <em className='actions-separator'>|</em>
                                                <DeleteButton
                                                    module={`grower`}
                                                    itemId={grower.id}
                                                    itemName={grower.name}
                                                    removeItemInListing={removeItemInListing}
                                                />
                                            </>
                                            }

                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]}
                    labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />

            </Paper>
        </div>
    );
}
